import React from 'react'

export default function LoadingOverlay({ visible, progress, tips }) {
  if (!visible) return null

  return (
    <section className="loading-overlay" aria-busy="true" aria-live="polite">
      <div className="loading-content">
        <div className="loading-bar-container">
          <div
            className="loading-bar"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div
          className="loading-img"
          style={{ left: `${progress}%` }}
        />
      </div>
      <p className="loading-tips">{tips}</p>
    </section>
  )
}
